// Firebase Web SDK initialization for FCM Web Push.
// Config values come from REACT_APP_FIREBASE_* env vars. If any required
// field is missing (e.g. apiKey/appId not yet pasted from Firebase Console)
// the module exports a `firebaseEnabled: false` flag and all push helpers
// silently no-op so the rest of the app keeps working.
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const cfg = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// Required fields for messaging to work. We do NOT require storageBucket etc.
const firebaseEnabled = Boolean(
  cfg.apiKey && cfg.projectId && cfg.messagingSenderId && cfg.appId && VAPID_KEY
);

let _app = null;
let _messaging = null;

function ensureApp() {
  if (!firebaseEnabled) return null;
  if (!_app) _app = initializeApp(cfg);
  return _app;
}

async function ensureMessaging() {
  if (!firebaseEnabled) return null;
  if (_messaging) return _messaging;
  try {
    const ok = await isSupported();
    if (!ok) return null;
    ensureApp();
    _messaging = getMessaging(_app);
    return _messaging;
  } catch (e) {
    console.warn("FCM messaging init failed:", e);
    return null;
  }
}

export { firebaseEnabled, VAPID_KEY, ensureMessaging, getToken, onMessage };
